import { render, staticRenderFns } from "./catalog-item-large-mobile.vue?vue&type=template&id=295453d7"
import script from "./catalog-item-large-mobile.vue?vue&type=script&lang=js"
export * from "./catalog-item-large-mobile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {CatalogItemTitle: require('/var/www/components/catalog/catalog-item/catalog-item-components/catalog-item-title.vue').default,CatalogItemPrice: require('/var/www/components/catalog/catalog-item/catalog-item-components/catalog-item-price.vue').default,CatalogItemImg: require('/var/www/components/catalog/catalog-item/catalog-item-components/catalog-item-img.vue').default,CatalogItemTechList: require('/var/www/components/catalog/catalog-item/catalog-item-components/catalog-item-tech-list.vue').default,CatalogItemButtons: require('/var/www/components/catalog/catalog-item/catalog-item-components/catalog-item-buttons.vue').default})
